export default "__VITE_ASSET__DvnGu_3w__"